import { Button, Result } from 'antd';
import { Outlet, useNavigate } from 'react-router';
import { ROUTES } from '@/constants';
import { canAccessResource } from '@/providers/accessControlProvider';
import { getImpersonatedRental, getStoredUser } from '@/services/auth';
import { isAdmin } from '@/types/models';

/**
 * Wraps the global vehicle model routes: platform data an Admin manages in Global view.
 * A denied session gets an explanation and the page never mounts, so its queries never start.
 */
export const GlobalVehicleModelsRouteGuard = (): React.JSX.Element => {
  const navigate = useNavigate();

  if (canAccessResource('global-vehicle-models')) return <Outlet />;

  const isImpersonatingAdmin = isAdmin(getStoredUser()) && getImpersonatedRental() !== null;

  return (
    <Result
      status="403"
      title="Global vehicle models are not available here"
      subTitle={
        isImpersonatingAdmin
          ? 'Global vehicle models are managed in Global view. Exit the impersonation to manage them, or use "Start from global list" on the vehicle model create page.'
          : 'Only platform admins can manage global vehicle models.'
      }
      extra={
        <Button
          type="primary"
          onClick={() => {
            void navigate(ROUTES.VEHICLE_MODELS);
          }}
        >
          Go to Vehicle Models
        </Button>
      }
    />
  );
};
